import React from 'react';
import {Text, useTheme} from '@fluentui/react';
import {ISuggestionReason} from './suggestedProductsLogic';

/**
 * Why a suggestion is being put forward, as a quiet pill.
 *
 * Deliberately neutral rather than brand-coloured: the same two or three words repeat on every card in the
 * strip and down every row of the panel, so a green chip would be the loudest thing on a surface whose actual
 * subject is the product and its cost. Takes the already-worked-out reason rather than the thing being
 * suggested, so products and bundles, which reason about their sources differently, share one chip.
 */
const SuggestionReasonChip: React.FC<{reason: ISuggestionReason}> = ({reason}) => {
    const theme = useTheme();
    return (
        <Text
            nowrap
            title={reason.tooltip}
            styles={{root: {
                display: 'inline-block',
                fontSize: 11,
                lineHeight: 16,
                padding: '1px 8px',
                borderRadius: 10,
                background: theme.palette.neutralLighterAlt,
                color: theme.palette.neutralSecondary,
                border: `1px solid ${theme.palette.neutralLight}`,
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            }}}
        >
            {reason.label}
        </Text>
    );
};

export default SuggestionReasonChip;
